export const HeatIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M16.5251 0.833313L17.5291 2.36473C18.8782 4.42278 18.4896 7.34672 16.6667 8.8529C14.9427 10.2774 14.4866 12.9917 15.6262 15.0459L16.5251 16.6666" />
        <path d="M9.8585 0.833313L10.8624 2.36473C12.2115 4.42278 11.8229 7.34672 10.0001 8.8529C8.27608 10.2774 7.82002 12.9917 8.95953 15.0459L9.8585 16.6666" />
        <path d="M2.73979 0.833313L3.99468 2.36473C5.6811 4.42278 5.19532 7.34672 2.91675 8.8529C0.761755 10.2774 0.191697 12.9917 1.61605 15.0459L2.73979 16.6666" />
        <path d="M0.833374 19.1667H19.1667" />
      </g>
    </svg>
  );
};
